import React from 'react';
import { ArrowRightIcon, CheckIcon, BookOpenIcon, MicIcon, CalendarIcon, LayersIcon } from 'lucide-react';
import { PageTransition } from '../../components/layout/PageTransition';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { DecorativeShape } from '../../components/DecorativeShape';
import { Animate } from '../../components/ui/Animate';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
export function ConflictAndConversations() {
  const {
    t
  } = useLanguage();
  const signs = t('conflictAndConversations.signs') as string[];
  const whatWeDoItems = t('conflictAndConversations.whatWeDoItems') as string[];
  return <PageTransition data-id="element-1525" data-mp="2xfyq6lqzmduj">
      <div className="pt-12 pb-24" data-id="element-1526" data-mp="2xff5wydv7ddc">
        {/* Hero */}
        <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1527" data-mp="29qcrdzej20n2">
          <DecorativeShape type="blob" color="bg-teal/10" className="top-0 right-0 w-[500px] h-[500px] translate-x-1/4 -translate-y-1/4 -z-10" data-id="element-1528" data-mp="25p0ztoc3f5c8" />
          <Animate className="max-w-3xl" data-id="element-1529" data-mp="22wg0zpmb0r9u">
            <span className="inline-block px-4 py-2 bg-teal/10 text-teal font-medium rounded-full text-sm mb-6" data-id="element-1530" data-mp="22veqpnd448t6">
              {t('conflictAndConversations.badge')}
            </span>
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-1531" data-mp="2cmhoogaqw7o8">
              {t('conflictAndConversations.title')}
              <br data-id="element-1532" data-mp="1f1n43as3v51p" />
              <span className="text-teal" data-id="element-1533" data-mp="1jy3opv03j1a1">
                {t('conflictAndConversations.titleHighlight')}
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-6 leading-relaxed" data-id="element-1534" data-mp="1own9vt6v891c">
              {t('conflictAndConversations.intro1')}
            </p>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-1535" data-mp="30clsannxo7f8">
              {t('conflictAndConversations.intro2')}
            </p>
            <Link to="/contact" data-id="element-1536" data-mp="35ana759mi0p4">
              <Button size="lg" rightIcon={<ArrowRightIcon size={20} data-id="element-1538" data-mp="159gnlfksxihc" />} data-id="element-1537" data-mp="359vg5yvocb0y">
                {t('conflictAndConversations.heroCta')}
              </Button>
            </Link>
          </Animate>
        </section>

        {/* Signs */}
        <section className="bg-cream py-20 mb-20" data-id="element-1539" data-mp="1ea51maa73iu8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1540" data-mp="1e9ll8y0712ib">
            <Animate className="mb-12" data-id="element-1541" data-mp="1a80abi77yyar">
              <h2 className="text-3xl font-bold text-charcoal" data-id="element-1542" data-mp="1a9bg1nk86g4i">
                {t('conflictAndConversations.signsTitle')}
              </h2>
            </Animate>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1543" data-mp="hknqvgwcv6lo">
              {signs.map((sign, i) => <Animate key={i} delay={i * 0.05} data-id="element-1544" data-mp="vcawi7c6trh4" data-mpi={i}>
                  <div className="flex items-start gap-3 bg-white rounded-2xl p-5 shadow-sm" data-id="element-1545" data-mp="qkkk7vtowtn2">
                    <div className="mt-0.5 p-1 rounded-full bg-teal/10 text-teal flex-shrink-0" data-id="element-1546" data-mp="qipwyauy4pft">
                      <CheckIcon size={14} strokeWidth={3} data-id="element-1547" data-mp="2slwgcd215t1" />
                    </div>
                    <span className="text-gray-700" data-id="element-1548" data-mp="3uwofnv6k25nu">{sign}</span>
                  </div>
                </Animate>)}
            </div>
          </div>
        </section>

        {/* What we work on */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1549" data-mp="3pndlq0mha384">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-1550" data-mp="3ayheg5s8wu8k">
            <Animate data-id="element-1551" data-mp="3fwiwcndxqnig">
              <h2 className="text-3xl font-bold text-charcoal mb-6" data-id="element-1552" data-mp="3fw0r519aoyye">
                {t('conflictAndConversations.whatWeDoTitle')}
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-1553" data-mp="cfk8013gocy6">
                {t('conflictAndConversations.whatWeDoP1')}
              </p>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1554" data-mp="3tmw1khzfzo43">
                {t('conflictAndConversations.whatWeDoP2')}
              </p>
            </Animate>
            <Animate delay={0.1} data-id="element-1555" data-mp="2i6xom3158hxl">
              <div className="space-y-3" data-id="element-1556" data-mp="2ia3g1ox8vvwh">
                {whatWeDoItems.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-1557" data-mp="2n8dcs3ymb4k7" data-mpi={i}>
                    <div className="mt-1 p-1 rounded-full bg-teal/10 text-teal flex-shrink-0" data-id="element-1558" data-mp="33f9qa3fj4jvf">
                      <CheckIcon size={14} strokeWidth={3} data-id="element-1559" data-mp="2ymgnhl3mfllz" />
                    </div>
                    <span className="text-gray-700" data-id="element-1560" data-mp="2tnluxrfuqioo">{item}</span>
                  </div>)}
              </div>
            </Animate>
          </div>
        </section>

        {/* Ways to work together */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1561" data-mp="3mc14vzk4mat5">
          <Animate className="mb-12" data-id="element-1562" data-mp="3hdg8kb7zwb9z">
            <h2 className="text-3xl font-bold text-charcoal" data-id="element-1563" data-mp="3heiv66yabrk3">
              {t('conflictAndConversations.waysTitle')}
            </h2>
            <p className="text-gray-500 mt-2" data-id="element-1564" data-mp="37ftpdcjnxxk7">
              {t('conflictAndConversations.waysSubtitle')}
            </p>
          </Animate>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1565" data-mp="210spivriov8c">
            {[{
            icon: <BookOpenIcon size={24} className="text-coral" data-id="element-1566" data-mp="1vzvaut5pujbl" />,
            typeBg: 'bg-coral/10 text-coral',
            typeKey: 'courseLabel',
            titleKey: 'course1Title',
            descKey: 'course1Desc',
            path: '/services/courses/conflict-coaching'
          }, {
            icon: <LayersIcon size={24} className="text-teal" data-id="element-1567" data-mp="leyv9zl1pnks" />,
            typeBg: 'bg-teal/10 text-teal',
            typeKey: 'workshopLabel',
            titleKey: 'workshop1Title',
            descKey: 'workshop1Desc',
            path: '/services/workshops'
          }, {
            icon: <MicIcon size={24} className="text-yellow-600" data-id="element-1568" data-mp="147jaie7tnu64" />,
            typeBg: 'bg-yellow-100 text-yellow-700',
            typeKey: 'talkLabel',
            titleKey: 'talk1Title',
            descKey: 'talk1Desc',
            path: '/services/talks'
          }].map((item, i) => <Animate key={i} delay={i * 0.1} data-id="element-1569" data-mp="3aysfwsja3bcz" data-mpi={i}>
                <Card hoverEffect className="h-full p-6 flex flex-col" data-id="element-1570" data-mp="3azkco6om3f4u">
                  <div className="flex items-center gap-3 mb-4" data-id="element-1571" data-mp="32xjp3yerfhid">
                    {item.icon}
                    <span className={`text-xs font-bold px-3 py-1 rounded-full ${item.typeBg}`} data-id="element-1572" data-mp="2yx0yg7olshhr">
                      {t(`conflictAndConversations.${item.typeKey}`)}
                    </span>
                  </div>
                  <h3 className="font-bold text-lg text-charcoal mb-2" data-id="element-1573" data-mp="3lve0gj3d253x">
                    {t(`conflictAndConversations.${item.titleKey}`)}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed flex-1 mb-4" data-id="element-1574" data-mp="3hshkl057gn3o">
                    {t(`conflictAndConversations.${item.descKey}`)}
                  </p>
                  <Link to={item.path} data-id="element-1575" data-mp="3qn5n4ijebqos">
                    <Button variant="outline" size="sm" rightIcon={<ArrowRightIcon size={16} data-id="element-1577" data-mp="4fxpk2epwo3b" />} data-id="element-1576" data-mp="9e8zse8xd0m2">
                      {t('conflictAndConversations.learnMore')}
                    </Button>
                  </Link>
                </Card>
              </Animate>)}
          </div>
        </section>

        {/* CTA */}
        <section className="max-w-4xl mx-auto px-4 text-center" data-id="element-1578" data-mp="e3jiugh96p05">
          <Animate data-id="element-1579" data-mp="e5e2lrgsgb2n">
            <Card className="p-12 bg-gradient-to-br from-teal/5 to-cyan-50 border-0" data-id="element-1580" data-mp="j1usaq3myxhu">
              <div className="w-16 h-16 mx-auto mb-6 bg-white rounded-full flex items-center justify-center shadow-md" data-id="element-1581" data-mp="4d8c6m66q1pk">
                <CalendarIcon size={32} className="text-teal" data-id="element-1582" data-mp="94gobpywg16f" />
              </div>
              <h2 className="text-3xl font-bold mb-4" data-id="element-1583" data-mp="3rhwi6muvsw5c">
                {t('conflictAndConversations.ctaTitle')}
              </h2>
              <p className="text-gray-600 mb-8 max-w-xl mx-auto" data-id="element-1584" data-mp="cogln19f65j">
                {t('conflictAndConversations.ctaDesc')}
              </p>
              <Link to="/contact" data-id="element-1585" data-mp="3hltl3vevznp9">
                <Button variant="secondary" rightIcon={<ArrowRightIcon size={18} data-id="element-1587" data-mp="3mko2csx7h479" />} data-id="element-1586" data-mp="3mijwi5fqxv4c">
                  {t('conflictAndConversations.ctaCta')}
                </Button>
              </Link>
            </Card>
          </Animate>
        </section>
      </div>
    </PageTransition>;
}